import { Grid, Typography } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import BannerCoursesDurationFee from "../../muiCommonComponent/bannerCoursesDurationFee";
import { ListDataPresentation, TableDataPresentation } from "../../../utils/utils";
const MPharma=()=>{
    const progHiglight=[
{listName:'Why Choose M. Pharmacy at MVN University?'},
{listName:'Unlock Your Future in Pharmaceutical Sciences with a PCIApproved Program'},
{listName:'MVN University s M. Pharmacy program, approved by the Pharmacy Council of India (PCI), offers a robust academic and practical foundation for aspiring pharmaceutical professionals. Here’s why our program stands out:'},
{listName:'PCIApproved Curriculum - Our curriculum is meticulously designed in line with PCI standards, ensuring comprehensive coverage of contemporary pharmaceutical sciences and industry practices. Graduating from a PCIrecognized program enhances your credibility and eligibility for professional registration and licensing across India.'},
{listName:'Industry-Ready Skill Development'},
{listName:'The course integrates advanced theoretical knowledge with extensive hands-on training. Students gain expertise in:'},
{listName:'Drug formulation and development'},
{listName:'Clinical research and pharmacovigilance'},
{listName:'Regulatory affairs and quality assurance'},
{listName:'Analytical techniques and instrumentation'},
{listName:'State-of-the-Art Infrastructure - MVN University provides access to modern laboratories, research facilities, and digital resources, enabling students to engage in innovative research and real-world applications of pharmaceutical sciences.'},
{listName:'Expert Faculty & Research Opportunities - Learn from a team of experienced academicians and industry professionals. Our faculty actively mentor students in research projects, encouraging publication, patent filing and participation in national and international conferences.'},


    
    ]
    const feeStructureData=[
        {duration:'1st Year Onwards Fees','2 Years':'₹1,00,000/- (Tuition Fee - ₹80,000 + Other Charges- ₹20,000/-)'},
        // {duration:'2nd Year Onwards Fees','2 Years':'₹124000/- ( Tuition Fee – ₹107000 + Other Charges- ₹20000/-)'}
    ]
    const hostalFeeData=[
        {item:'Triple Seater with Meal','fee':'₹ 96000/-'},
        {item:'Triple Seater (AC) with Meal','fee':'₹130000/-'}
    ]
    const duration='2 years'
    const fee_1st= '1,00,000'
    const fee_2nd= '1,00,000'
    const eligibility='Candidate shall have a B. Pharm degree from reputed University/ college approved by Pharmacy Council of Indiawith Minimum 55%or 6.0 CGPA. '
return (
<Grid container spacing={2}>
<Grid item xs={12}>
<BannerCoursesDurationFee duration={duration} fee_1st={fee_1st} fee_2nd={fee_2nd} eligibility={eligibility}/>
    </Grid>
<Grid item xs={12}>
    <MainTitle title="M. Pharmacy" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="About the Program" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    The M. Pharmacy program at the School of Pharmaceutical Sciences, MVN University, Palwal, has quickly become a cornerstone for aspiring researchers in the pharmaceutical field since its inception in 2021. Designed to meet the growing demands of the research community, the program has consistently fostered an environment conducive to excellent research work.
<br/><br/>
One of the key strengths of the program lies in its dedicated faculty members who bring a wealth of knowledge and experience to the classroom and research labs. Their guidance and mentorship play a pivotal role in nurturing the talents of students and facilitating ground breaking research. Moreover, the program's strategic tie-ups with top-notch companies further enhance the learning experience by providing students with opportunities for practical exposure and industry-relevant projects. These collaborations not only enrich the curriculum but also open doors to potential career pathways for students.
<br/><br/>
Overall, the M. Pharmacy program at the School of Pharmaceutical Sciences, MVN University, Palwal, stands out as a beacon of excellence in pharmaceutical education and research, shaping the future leaders and innovators of the field.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Eligibility" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" fontWeight={800} >
    Minimum Eligibility Criteria <br/><br/>
    </Typography>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Minimum qualification for admission in M. Pharmacy.
 <br/>
 B. Pharm Degree examination of an Indian university established by law in India from an institution approved by Pharmacy Council of India and has scored not less than 55 % of the maximum marks (aggregate of 4 years of B.Pharm.) 
<br/>
 Every student, selected for admission to post graduate pharmacy program in any PCI approved institution should have obtained registration with the State Pharmacy Council or should obtain the same within one month from the date of his/her admission, failing which the admission of the candidate shall be cancelled.

    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Programme Highlights" />
    </Grid>

    <Grid item xs={12}>
    <ListDataPresentation DataList={progHiglight}/>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Fee Structure" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    The comprehensive fee structure is designed to be transparent, helping you and your family plan effectively for all four years of the program. Below, you will find a detailed breakdown of tuition fees, including specific costs for the first year and subsequent years.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
   M. Pharmacy
    </Typography>
    <TableDataPresentation data={feeStructureData}/>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Ensure your comfort and convenience while studying at our institution with our range of hostel accommodations. We offer various options to suit your preferences, including triple seater rooms, both air-conditioned and non-air-conditioned, complete with meal plans. Below, you’ll find detailed information on our hostel fee structures for each option.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    Hostel Fee
    </Typography>
    <TableDataPresentation data={hostalFeeData}/>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='justify' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <b>Note:</b> Hostel Caution Money of ₹10,000/- One Time Payment (Refundable) <br/><br/>
    </Typography>
    </Grid>
    </Grid>

)
}
export default MPharma;